import { EventBus } from 'chimera/all/plugins/eventbus'

const VARIANT_NAME_ALIASES = {
  control: 0,
  test: 1,
  treatment: 1,
  variant: 1,
}

const VARIANT_NAME_PATTERN = /^v(?:ariant)?[\s_-]*(\d+)$/

/**
 * Map a Statsig `groupName` (string|null) to a numeric variant.
 * Number() on non-numeric labels yields NaN and breaks isControl/isVariant.
 *
 * @param {string|number|null|undefined} input
 * @param {string} [experimentId]
 * @returns {number}
 */
export function resolveVariant(input, experimentId) {
  // null is the SDK's documented "no group" state (user not in experiment) — silent.
  if (input === null) {
    return 0
  }

  const trimmed = String(input).trim()
  const numeric = Number(trimmed)
  if (trimmed !== '' && Number.isFinite(numeric)) {
    return numeric
  }

  const normalized = trimmed.toLowerCase()
  if (normalized in VARIANT_NAME_ALIASES) {
    return VARIANT_NAME_ALIASES[normalized]
  }

  const match = normalized.match(VARIANT_NAME_PATTERN)
  if (match) {
    return Number(match[1])
  }

  EventBus.emitWarningAppErrorEvent(
    new Error(
      `statsig/resolveVariant: unrecognized groupName ${JSON.stringify(input)}`,
    ),
    { context: 'statsig/resolveVariant', experimentId, groupName: input },
  )
  return 0
}

export default resolveVariant
